import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

type ClsxValue = Parameters<typeof clsx>[number]

export function cn(...inputs: ClsxValue[]) {
  return twMerge(clsx(inputs))
}
